import request from '@/utils/request'

export function webSiteConfigImport(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/website/config/import',
        method: 'post',
        data
    })
}

export function getOrganizationList(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/organization/list',
        method: 'get',
        params: data
    })
}
export function getMenuTreeList(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/menu/treelist',
        method: 'get',
        params: data
    })
}

export function getWebSiteList(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/website/list',
        method: 'get',
        params: data
    })
}

export function getWebSitePageList(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/website/pagelist',
        method: 'get',
        params: data
    })
}


export function editWebSiteList(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/website/edit',
        method: 'post',
        data
    })
}

export function delWebSiteList(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/website/delete',
        method: 'post',
        contentType: 'json',
        data: '"' + data.ID + '"'
    })
}

export function getConfigMenuList(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/website/config/children',
        method: 'get',
        params: data
    })
}

export function getModuleList(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/website/config/edittree',
        method: 'get',
        params: data
    })
}

//保存菜单
export function editMenuRow(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/website/config/edit',
        method: 'post',
        data
    })
}

//删除菜单
export function delMenuList(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/website/config/delete',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/areas/systemmanage/api/site.js